import React from 'react'

const NotFound = () => {
  return (
    <div className=' d-flex align-content-center justify-content-center'>
        <img src="/images/2748558.png" alt="" className=' w-100 h-100'/>
    </div>
  )
}

export default NotFound